export default class QuantityControl {
	public static outerSelector = ".exto-product-quantity";
	private plusButtons: Array<Element> = [];
	private minusButtons: Array<Element> = [];
	private boxQuantityLabels: Array<Element> = [];
	private innerQuantityLabels: Array<Element> = [];
	private baseQty: number = 0;
	private total: number = 0;
	private boxQty: number = 1;
	private maxQty: number = 0;

	/**
	 * @param element
	 * @param onChange
	 */
	constructor(
		private element: HTMLDivElement,
		public onChange: (newQuantity: number) => void,
	) {
		this.onChange = onChange;
		this.setInitialNumericValues();
		this.setElementsFromPage();
		this.setInnerQuantityLabelsText(this.total.toString());
		this.setBoxQuantityLabelsText();
		this.registerListeners();
		this.setButtonStates();
	}

	public getInnerQuantity(): number {
		return this.total;
	}

	public getBoxQuantity(): number {
		return this.boxQty;
	}

	private setInitialNumericValues(): void {
		const { dataset } = this.element;
		const { initialQuantity, base, max } = dataset;
		if (!initialQuantity || !base || !max) {
			throw new Error("Box data missing");
		}
		this.boxQty = Number.parseInt(initialQuantity);
		this.baseQty = Number.parseInt(base);
		this.maxQty = Number.parseInt(max);
		this.total = this.baseQty * this.boxQty;
	}

	private setElementsFromPage(): void {
		const { element } = this;
		this.plusButtons = Array.from(
			element.querySelectorAll(".exto-quantity-control .exto-plus"),
		);

		this.minusButtons = Array.from(
			element.querySelectorAll(".exto-quantity-control .exto-minus"),
		);
		this.boxQuantityLabels = Array.from(
			element.querySelectorAll(".exto-box-quantity"),
		);
		this.innerQuantityLabels = Array.from(
			element.querySelectorAll(".exto-inner-quantity"),
		);
	}

	/** @param delta */
	private handleChange(delta: number): void {
		this.boxQty += delta;
		this.total = this.baseQty * this.boxQty;
		this.setInnerQuantityLabelsText(this.total.toString());
		this.setBoxQuantityLabelsText();
		this.onChange(this.boxQty);
		this.setButtonStates();
	}

	private setButtonStates(): void {
		if (this.boxQty === 1) {
			this.disableMinusButtons();
		} else {
			this.enableMinusButtons();
		}
		if (this.boxQty === this.maxQty) {
			this.disablePlusButtons();
		} else {
			this.enablePlusButtons();
		}
	}

	private enableMinusButtons(): void {
		this.setButtonsEnabledStatus(this.minusButtons, false);
	}

	private disableMinusButtons(): void {
		this.setButtonsEnabledStatus(this.minusButtons, true);
	}

	private enablePlusButtons(): void {
		this.setButtonsEnabledStatus(this.plusButtons, false);
	}

	private disablePlusButtons(): void {
		this.setButtonsEnabledStatus(this.plusButtons, true);
	}

	/**
	 * @param buttons
	 * @param isDisabled
	 */
	private setButtonsEnabledStatus(
		buttons: Array<Element>,
		isDisabled: boolean,
	): void {
		buttons.forEach((btn) => {
			(btn as HTMLButtonElement).disabled = isDisabled;
		});
	}

	private registerListeners(): void {
		this.plusButtons.forEach((btn) =>
			btn.addEventListener("click", () => this.handleChange(1)),
		);
		this.minusButtons.forEach((btn) =>
			btn.addEventListener("click", () => this.handleChange(-1)),
		);
	}

	/** @param text */
	private setInnerQuantityLabelsText(text: string): void {
		this.innerQuantityLabels.forEach((lbl) => (lbl.textContent = text));
	}

	private setBoxQuantityLabelsText(): void {
		const text = this.boxQty + " Case" + (this.boxQty > 1 ? "s" : "");
		this.boxQuantityLabels.forEach((lbl) => (lbl.textContent = text));
	}
}
